export default __webpack_public_path__ + "static/media/21.49de1458.jpg";